import moment, { Moment } from "moment";

// Report filter persistence (MAX-3930): the report pages reflect their date/type filters in the URL
// query string — the spec-directed replacement for CF's per-client server session vars — so a user's
// selections survive back-nav / refresh / share. Parse leniently (CF's isDate() is tolerant); fall
// back to the page default on an absent or invalid param.
export const parseDateParam = (search: string, key: string): Moment | null => {
	const raw = new URLSearchParams(search).get(key);
	if (!raw) {
		return null;
	}
	const parsed = moment(raw);
	return parsed.isValid() ? parsed : null;
};

export const parseIntParam = (search: string, key: string): number | null => {
	const raw = new URLSearchParams(search).get(key);
	if (raw === null || raw.trim() === "") {
		return null;
	}
	const parsed = Number(raw);
	return Number.isNaN(parsed) ? null : parsed;
};
